"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNativeOperationTask = exports.getOperationAndTapes = void 0;
const common_1 = require("@finley-technologies/common");
const operationConvertors_1 = require("./operationConvertors");
const uiNodes_1 = require("./uiNodes");
const utils_1 = require("./utils");
const getOperationAndTapes = ({ node, graph, }) => {
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    const operations = inputNodes.filter((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        return uiNode.isOperation;
    });
    (0, common_1.finleyAssert)(operations.length <= 1, `only 1 or 0 operations were expected. found ${operations.length}`);
    let operationNode = null;
    if (operations.length === 1) {
        const operationUINode = (0, uiNodes_1.getUINodeByType)(operations[0].metadata.tapeBuilderNodeType);
        (0, common_1.finleyAssert)(operationUINode.isOperation, 'expected all srcTapes to be tape nodes');
        operationNode = operationUINode.getOperationNode(operations[0]);
    }
    // in there was an operation node, it must be the only inputNode.
    (0, common_1.finleyAssert)(operationNode === null || inputNodes.length === 1, 'expected just 1 input operation node');
    const srcTapes = operationNode
        ? (0, utils_1.getSourceNodes)({ node: operationNode, graph })
        : inputNodes;
    // we expect all srcTapes to be tape nodes
    const tapeNodes = srcTapes.map((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        (0, common_1.finleyAssert)(!uiNode.isOperation, 'expected all srcTapes to be tape nodes');
        return uiNode.getTapeNode(srcNode);
    });
    return {
        operationNode,
        srcTapes: tapeNodes,
    };
};
exports.getOperationAndTapes = getOperationAndTapes;
// For tapes produced by a native (tape-builder) operation: the operation node
// feeding `node`, and the task it converts to.
const getNativeOperationTask = ({ node, graph, }) => {
    const { operationNode, srcTapes } = (0, exports.getOperationAndTapes)({
        node,
        graph,
    });
    (0, common_1.finleyAssert)(operationNode, 'uiNodesToIntermediate: operationNode is null');
    (0, common_1.finleyAssert)((0, uiNodes_1.isTapeBuilderNativeOperationNode)(operationNode), `operationNode is not a TapeBuilderOperationNode: ${operationNode.metadata.tapeBuilderNodeType}`);
    const task = (0, operationConvertors_1.taskFromOperationNode)({
        srcNodes: srcTapes,
        operationNode,
    });
    return { operationNode, task };
};
exports.getNativeOperationTask = getNativeOperationTask;
//# sourceMappingURL=conversionUtils.js.map